import { render, staticRenderFns } from "./Komisi.vue?vue&type=template&id=0f1eb6f2&"
import script from "./Komisi.vue?vue&type=script&lang=js&"
export * from "./Komisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports